var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.432 190.863C98.492 190.863 126.863 162.492 126.863 127.432S98.492 64 63.432 64S0 92.371 0 127.432S28.371 190.863 63.432 190.863ZM320.568 321.137C285.508 321.137 257.137 349.508 257.137 384.568S285.508 448 320.568 448S384 419.629 384 384.568S355.629 321.137 320.568 321.137ZM372.281 75.719C356.656 60.094 331.344 60.094 315.719 75.719L11.719 379.719C-3.906 395.344 -3.906 420.656 11.719 436.281C19.531 444.094 29.766 448 40 448S60.469 444.094 68.281 436.281L372.281 132.281C387.906 116.656 387.906 91.344 372.281 75.719Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.9982c1ba7285374cd62b3c11533aa283.svg";
export { ForwardRef as ReactComponent };